import React from "react";
import { NavLink } from "react-router-dom";

const PropsList = ({ propItems, filmId }) => {
  return (
    <aside className="menu">
      <p className="menu-label">Props</p>
      <ul className="menu-list">
        <li>
          <NavLink
            to={`/films/${filmId}/props/overview`}
            activeClassName="is-active">
            Overview
          </NavLink>
        </li>
        <hr />
        {propItems?.map((prop, idx) => {
          return (
            <li key={idx}>
              <NavLink
                to={`/films/${filmId}/props/${prop.id}/edit`}
                title={prop.name}
                activeClassName="is-active"
                isActive={(match, location) => {
                  return location.pathname.startsWith(
                    `/films/${filmId}/props/${prop.id}`
                  );
                }}>
                {prop.name}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </aside>
  );
};

export default PropsList;
